var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.344 10a.47.47 0 0 1-.469.469h-6.406v6.406a.47.47 0 0 1-.938 0v-6.406H3.125a.469.469 0 0 1 0-.938h6.406V3.125a.469.469 0 0 1 .938 0v6.406h6.406a.47.47 0 0 1 .469.469"
  })));
};
export default SvgPlus;